document.addEventListener('DOMContentLoaded', function (event) {
  let lastScrollTop = 0

  window.onscroll = function () {
    // header sticky
    const header = document.querySelectorAll('.header > header')[0]
    const scrollTop = window.pageYOffset
    if (scrollTop > 0) {
      header.classList.add('sticky')
    } else {
      header.classList.remove('sticky')
    }

    // tab sticky
    if (document.querySelectorAll('.tab-wrap')[0]) {
      header.classList.add('no-shadow')
      const tab = document.querySelectorAll('.tab-wrap')[0]
      const content = document.querySelectorAll('.content')[0]
      const tabPosFix = content.offsetTop - header.offsetHeight
      // const tabPosFix = tab.offsetTop - header.offsetHeight
      const tabPosClear = content.offsetTop - header.offsetHeight - tab.offsetHeight
      if (scrollTop > lastScrollTop && scrollTop > tabPosFix) {
        tab.classList.add('sticky')
      } else if (scrollTop < lastScrollTop && scrollTop <= tabPosClear) {
        tab.classList.remove('sticky')
      }
      lastScrollTop = scrollTop
    } else {
      header.classList.remove('no-shadow')
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/ui.js